import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function creative({  attributes, docSections, multiDocs, articlesNumber }) {
    
    const { col,  titleText, titleTag, docs_layout, imageUrl, sectionButton, sectionButtonText, child_docs_order, orderBy, isFeaturedImage } = attributes;

    const Title = () => {
        const tag = titleTag || 'h2';
        const Tag = titleTag;
        return <Tag className="title" data-animation="wow fadeInUp" data-wow-delay="0.2s">{titleText}</Tag>;
    };

    // Determine layout type based on attributes
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : `ezd-masonry-wrap ezd-masonry-col-${col}`;

    function ChildItems({ parentId, articlesNumber }) {
        const docItems = useSelect(
            (select) =>
                select("core").getEntityRecords("postType", "docs", {
                    per_page: articlesNumber || 10,
                    orderby: orderBy,
                    order: child_docs_order,
                    parent: parentId,
                    status: ["publish", "private"],
                }),
            [parentId, articlesNumber, orderBy, child_docs_order]
        );
            
        if ( ! docItems ) return;
        if (docItems.length === 0) return <ul className="ezd-list-unstyled"><li><a className="ct-content-text">No child items available</a></li></ul>
    
        return (
            <>
            <ul className="ezd-list-unstyled">
                {docItems.map((item) => (
                    <li key={item.id}>
                    <a className="ct-content-text" href="#">
                        {item.title.rendered}
                    </a>
                </li>
                ))}
            </ul>
        </>
        );
    }
    
    // Component for fetching and displaying featured image
    function FeaturedImage({ mediaId, title }) {
        const [imageUrls, setImageUrl] = useState("");

        useEffect(() => {
            if (mediaId) {
                wp.apiFetch({ path: `/wp/v2/media/${mediaId}` })
                    .then((media) => setImageUrl(media.source_url))
                    .catch((error) => console.error("Error fetching media:", error));
            }
        }, [mediaId]);

        return imageUrls ? <img src={imageUrls} /> : null;
    }

    return (
        <> 
           <section className="recommended_topic_area creative-style">
                <div className="recommended_topic_inner">
                    
                    <img src={imageUrl ?? ezdAssets.ezd_img_dir + '/widgets/docbg-shap.png'} className="doc_shap_one" alt="curve shape" />

                    <div className="doc_round one" data-parallax='{"x": -80, "y": -100, "rotateY":0}'></div>
                    <div className="doc_round two" data-parallax='{"x": -10, "y": 70, "rotateY":0}'></div>

                    <div className="doc_title text-center">
                        <Title />
                    </div>

                    <div className="ezd-container">
                        <div className={`${layoutType}`}>
                            {(docSections || multiDocs) && [...(docSections || []), ...(multiDocs || [])].map((section) => {

                                const { id, featured_media } = section;

                                return (
                                    <div className="recommended_item box-item wow fadeInUp" data-wow-delay="0.2s" key={section.id} >
                                         
                                        {isFeaturedImage && (
                                            <FeaturedImage mediaId={featured_media}  />
                                        )}

                                        <a href="#">
                                            <h3 className="ct-heading-text">
                                                {section.title.rendered}
                                            </h3>
                                        </a>
                                        
                                        <ChildItems parentId={id} articlesNumber={articlesNumber} />

                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {sectionButton && sectionButtonText && (
                        <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
                        <a href="" className="question_text"> 
                        {sectionButtonText} <i className="arrow_right"></i> 
                        </a>
                    </div>
                    )}
                </div>
            </section>
        </>
    );
}